<div class="content">
  <mat-card appearance="raised">
    <div class="text-box">
      <img [ngSrc]="'/assets/images/404.svg' | absUrl" alt="404" height="265" width="600" priority>
      <p>This isn't the page you're looking for.</p>
      <p>It either does not exist or it has moved.</p>
    </div>
  </mat-card>
</div>
